/**
 * Subscription Group Names pulling from Docebo
 * See the sub groups in the Beyond API
 * Note : Please do not change the names as they are used in Docebo. If they change in
 * Docebo, make sure Beyond API and here gets updated.
 */
export enum SubscriptionGroupName {
  AI_ESSENTIALS_USER_GROUP = 'AI Essentials Learning Subscription',
  GENESYS_CLOUD_USER_GROUP = 'GU - Genesys Cloud Learning Subscription holders',
  GENESYS_CLOUD_PREMIER_PARTNER_USER_GROUP = 'Genesys Cloud CX Partner Learning Premier',
  GENESYS_CLOUD_PARTNER_DIGITAL_PLUS_USER_GROUP = 'Genesys Cloud CX Partner Digital Plus Subscription',
  GENESYS_ENAGE_ON_PREMISES_USER_GROUP = 'GU - Genesys Engage Learning Subscription Holders',
  POINTILLIST_USER_GROUP = 'Pointillist Learning Subscription',
  PURECONNECT_USER_GROUP = 'GU - PureConnect Learning Subscription Holders',
}
